/*
 █████╗ ███████╗██████╗ ███████╗ ██████╗████████╗
██╔══██╗██╔════╝██╔══██╗██╔════╝██╔════╝╚══██╔══╝
███████║███████╗██████╔╝█████╗  ██║        ██║   
██╔══██║╚════██║██╔═══╝ ██╔══╝  ██║        ██║   
██║  ██║███████║██║     ███████╗╚██████╗   ██║   
╚═╝  ╚═╝╚══════╝╚═╝     ╚══════╝ ╚═════╝   ╚═╝   
*/
window.styleAspect = {
	local : null,
	onInit( elem ){
		this.local = !elem ? document : elem;
		const $div = this.local.querySelectorAll('.js-aspect');
		for (let i = 0; i < $div.length; i++) {
			const el = $div[i];
			const w = Number(el.dataset.w);
			const h = Number(el.dataset.h);
			el.style.aspectRatio = w+'/'+h;
		}
	}
}








//
// window.styleNav = {

// 	local : null,
// 	targets : [],

// 	once( elem ){
// 		this.local = !elem ? document : elem;
// 		const $hover = this.local.querySelectorAll('.js-hv');	
// 		for (let i = 0; i < $hover.length; i++) {
// 			const el = $hover[i];
// 			this.targets.push({
// 				el : el,
// 				mouseenter : null,
// 				mouseleave : null
// 			});
// 		}
// 		this.targets.forEach( (v,i) =>{
// 			v.mouseenter = () =>{

// 			}
// 			v.mouseleave = () =>{
				
// 			}
// 		});
// 	},

// 	onDestroy(){
		
// 	}

// }




/*
███████╗ ██████╗ ███╗   ██╗████████╗███████╗
██╔════╝██╔═══██╗████╗  ██║╚══██╔══╝██╔════╝
█████╗  ██║   ██║██╔██╗ ██║   ██║   ███████╗
██╔══╝  ██║   ██║██║╚██╗██║   ██║   ╚════██║
██║     ╚██████╔╝██║ ╚████║   ██║   ███████║
╚═╝      ╚═════╝ ╚═╝  ╚═══╝   ╚═╝   ╚══════╝
*/
// window.styleFonts = {
// 	notosan : 'https://fonts.googleapis.com/css2?family=Noto+Sans+JP:wght@350;400;500&display=swap',
// 	local : null,
// 	isloaded : false,
// 	timer : null,
// 	onInit(){
// 		if( !document.querySelector('.c-fontlink') ){
// 			let d = loadControl.font.d;
// 			clearTimeout( this.timer );
// 			this.timer = setTimeout( () => {
// 				const linkSecond = document.createElement('link');
// 				linkSecond.classList.add('c-fontlink');
// 				linkSecond.media = 'all';
// 				linkSecond.rel = 'stylesheet';
// 				$head.appendChild( linkSecond );
// 				linkSecond.href = this.notosan;
// 				// linkSecond.onload = () =>{
// 				// 	if( styleText ) if( styleText.ready ) styleText.onResize();
// 				// }
// 			}, d );
// 		}
// 	}
// }
// styleFonts.onInit();






/*
 ██████╗ ██████╗ ██████╗ ██╗   ██╗
██╔════╝██╔═══██╗██╔══██╗╚██╗ ██╔╝
██║     ██║   ██║██████╔╝ ╚████╔╝ 
██║     ██║   ██║██╔═══╝   ╚██╔╝  
╚██████╗╚██████╔╝██║        ██║   
 ╚═════╝ ╚═════╝ ╚═╝        ╚═╝   
*/
window.styleCopy = {

	local : null,
	array : [],
	wait  : 2000,

	onInit( elem ){

		//
		this.links = document.querySelectorAll('.js-copy');

		//
		if( !DETECT.device.any ){
			for (let i = 0; i < this.links.length; i++) {
				const v = this.links[i];
				const str = v.dataset.str ? v.dataset.str : v.textContent;
				this.array.push({
					el : v,
					str : str,
					click : null,
					timer : null
				});
			}
			this.addEvents();
		} else {
			for (let i = 0; i < this.links.length; i++) {
				const v = this.links[i];
				const str = v.dataset.str ? v.dataset.str : v.textContent;
				const mailto = 'mailto:'+str;
				v.setAttribute('href',mailto);
			}
		}

	},

	addEvents(){

		this.array.forEach( (v,i) =>{
			v.click = (e) =>{
				e.preventDefault();
				clearTimeout( v.timer );
				navigator.clipboard.writeText( v.str ).then(
				() => {
					v.el.classList.add('_ok');
					v.timer = setTimeout(()=>{
						v.el.classList.remove('_ok');
					}, this.wait);
				},
				() => {
					clearTimeout( v.timer );
					v.el.classList.remove('_ok');
				});
			}
			v.el.addEventListener('click', v.click );
		});

	},

	onDestroy(){
		this.array.forEach( (v,i) =>{
			if( v.click ){
				clearTimeout( v.timer );
				v.el.removeEventListener('click', v.click );
				v.click = null;
			}
		});
		this.array = [];
	}

}






/*
███╗   ███╗ █████╗ ██╗██╗  ████████╗ ██████╗ 
████╗ ████║██╔══██╗██║██║  ╚══██╔══╝██╔═══██╗
██╔████╔██║███████║██║██║     ██║   ██║   ██║
██║╚██╔╝██║██╔══██║██║██║     ██║   ██║   ██║
██║ ╚═╝ ██║██║  ██║██║███████╗██║   ╚██████╔╝
╚═╝     ╚═╝╚═╝  ╚═╝╚═╝╚══════╝╚═╝    ╚═════╝ 
*/
window.styleMail = {
	onInit(){
		this.links = document.querySelectorAll('.js-mailto');
		for (let i = 0; i < this.links.length; i++) {
			const el = this.links[i];
			const str = el.dataset.str;
			el.setAttribute('href','mailto:'+str);
		}
	}
}









/*
 ██████╗███████╗███████╗
██╔════╝██╔════╝██╔════╝
██║     ███████╗███████╗
██║     ╚════██║╚════██║
╚██████╗███████║███████║
 ╚═════╝╚══════╝╚══════╝
*/
window.styleCss = {
	elems : [],
	events : [],
	local : null,
	onInit( elem ){
		this.local = elem ? elem : document.querySelector('.c-local');
		const css  = document.querySelectorAll('.js-css');
		const fade = this.local.querySelectorAll('.c-fd-in');
		const slide = this.local.querySelectorAll('.c-sd-in');
		const border = this.local.querySelectorAll('.c-bd div');
		const clip = document.querySelectorAll('.c-cl .t');
		const flip = document.querySelectorAll('.c-fl .t');
		this.elems = [ ...css, ...fade, ...slide, ...clip, ...flip, ...border ];
		this.addEvents();
	},
	addEvents(){
		this.events = [];
		this.elems.forEach( (el,i) =>{
			const start = function(e){
				el.dataset.a = 1;
			};
			const end = function(e){
				el.dataset.a = 0;
			};
			el.addEventListener('transitionstart', start );
			el.addEventListener('transitionend', end );
			const events = {
				el : el,
				start : { func : start },
				end : { func : end }
			}
			this.events.push( events );
		});
	},
	onDestory(){
		for (let i = 0; i < this.events.length; i++) {
			const v = this.events[i];
			v.el.removeEventListener( 'transitionstart', v.start.func );
			v.el.removeEventListener( 'transitionend', v.end.func );
		}
		this.events = [];
		this.elems = [];
	},
}
















































































































































































































































































































































































































































































































































































